import { useEffect } from "react";
import { api } from "@/lib/api";

export default function AnalyticsLoader() {
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings");
        const id = data.ga4_id?.trim();
        if (!id || /^G-XXXX/i.test(id)) return;
        // Avoid double-injection
        if (document.getElementById("ga4-loader")) return;
        const s = document.createElement("script");
        s.id = "ga4-loader";
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(s);
        const inline = document.createElement("script");
        inline.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date()); gtag('config', '${id}');`;
        document.head.appendChild(inline);
      } catch {}
    })();
  }, []);
  return null;
}
